function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "map",
  transform: "translate(0.000000, -3.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 3.000000)"
}, React.createElement("path", {
  d: "M0,22 L28,22 L28,0 L0,0 L0,22 Z M2,20 L2,2 L26,2 L26,20 L2,20 Z",
  id: "Stroke-1"
}), React.createElement("path", {
  d: "M6,13.2186075 L6,16 L7.95426462,16 C9.97615796,15.80838 12.0702603,14.341863 13.4342747,12.3204912 C12.7548564,11.9326429 12.1491698,11.4139492 11.6655385,10.7999158 C11.230997,11.3912686 10.6857407,11.8971731 10.0173652,12.2770974 C8.86546606,12.9323848 7.50865257,13.2228771 6,13.2186075 Z M6,11.2181753 C7.18666179,11.2212564 8.21209637,11.0030976 9.02872779,10.538536 C10.3968926,9.76083063 11.0391722,7.85387539 11.0557028,6 L6,6 L6,11.2181753 Z M13.0585004,5.99999993 C13.0572114,6.89269579 12.9446596,7.79244816 12.7015769,8.63629732 C13.2736948,10.0942512 14.8513326,11.1605743 16.4184028,11.0889492 C16.5834304,11.0813835 16.7233629,11.0688276 17.0676293,11.0332356 C17.1574657,11.0239524 17.1574657,11.0239524 17.2496867,11.014658 C18.6206191,10.878163 19.4129717,10.9734487 20.1739246,11.6667459 C20.7977515,12.2385871 21.0584424,13.0237472 21.1163566,13.9922086 C21.1572042,14.6640054 21.1112532,15.339985 20.9813653,16 L22,16 L22,10.8981615 C20.7555598,11.1783527 19.4032829,10.9746332 18.3142122,10.2884553 C16.8756763,9.38015662 15.9995758,7.69354646 16.0589747,6 L13.0584993,6 Z M18.9295126,16 C19.0935204,15.3863032 19.1585309,14.7465712 19.1199833,14.112594 C19.0900322,13.6117462 18.9824367,13.2876854 18.8247216,13.1431069 C18.627914,12.963799 18.2800217,12.9219626 17.4478342,13.0048182 C17.3616643,13.0135023 17.3616643,13.0135023 17.2733032,13.022632 C16.8899648,13.0622635 16.7266324,13.0769191 16.5098587,13.0868571 C16.1244655,13.104472 15.7408982,13.0794735 15.3647523,13.0159729 C14.6615777,14.162109 13.7624803,15.1835133 12.7446789,16 L18.9295111,16 Z M18.0611552,6 C17.9984857,7.00774264 18.5278899,8.05806307 19.3811727,8.59683054 C20.1435167,9.07715133 21.16249,9.14887198 22,8.81017781 L22,6 L18.0611552,6 Z M4,18 L4,4 L24,4 L24,18 L4,18 Z",
  id: "Combined-Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "22px",
    viewBox: "0 0 28 22",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/map.02311dc3.svg";
export { SvgComponent as ReactComponent };